
import { Injectable } from '@angular/core';
import * as models from '../../shared/model/api';
import * as postalModels from '../../shared/model/api/PostalAddress'
import { isNil, keysIn,get } from 'lodash-es';
import { ViewConstants } from '../../constants';
import { ScreenMessages } from '../../shared/master-data/messages';
import { Observable, BehaviorSubject } from 'rxjs';
import { ScreenLabels } from '../../shared/master-data/screen-labels';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { DealDetailView } from 'src/app/shared/model/view-model/deal-detail-view';
import { getMyTheme } from '../state/selectors';
import { Store } from '@ngrx/store';
import { IAppCoreState } from '../state';
@Injectable(
    { providedIn: 'root' }
)
export class SharedDataService {
    appliedSellingPrice=null;
    hasFinalized = false;
    isDarkTheme = false;
    currentActiveTab: string = 'writeups';
    tabId: '';
    applyForCreditButton = false;
    actualDealStatus:string = null;
    dealerbaseUrl:string = null;
    dealerStateOrProvinceId:string = null;
    webSocketConnectionID:string;
    protectionProductsOnLoad: any;
    sessionExpiredAlert: boolean = false;
    openDFISuccessDialog = new BehaviorSubject(false);
    isWriteup: boolean = true;
    summaryPageActiveTab = new BehaviorSubject('writeups');
    managerName='';
    isAll: boolean = false;
    isAllWriteups: boolean = false;
    isAllLeads: boolean = false;
    isSignAndDriveLease: boolean = false;
    isSignAndDriveOrOnePayLease: boolean = false;
    leadsFromDate: any;
    holdEditedAccessories:any=[];
    totalCost:number=0;
    leadsToDate: any;
    dealTransacId: string = '';
    leadsAppliedFilters: [] = [];
    leadsFilterOptions:any[] = [];
    writeupsFromDate: any;
    writeupsToDate: any;
    isResetButtonClicked = false;
    writeupsDateRangeFilterLabel: string = '';
    leadsDateRangeFilterLabel: string = '';
    byCustomerDateRangeFilterLabel: string = '';
    writeupsAppliedFilters: [] = [];
    salesTeams: any[];
    byCustomerFromDate;
    byCustomerToDate;
    byCustomerFilterOptions:any[] = [];
    writeupLogs:any[] = [];
    totalIncentiveRebate:any={};
    isModel: boolean = false;
    rightPanelProtectionProductActiveCard : boolean;
    isGridClicked:boolean=true;
    isSPClicked:boolean=false;
    isAddOnsClicked:boolean=false;
    isIncentivesClicked:boolean=false;
    isPPClicked:boolean=false;
    isTaxesClicked:boolean=false;
    isTradeClicked:boolean=false;
    isNotesClicked:boolean=false;
    isLogClicked:boolean=false;
    isApplyForCreditClicked: boolean=false;
    iscalculateTriggered:boolean = false;
    isCalculateEnabled:boolean=false;
    isPencil:boolean = false;
    customerData:any = null;
    isunsavedPopup:boolean = false;
    isUsed:boolean = false;
    isUsedOrCertified:boolean = false;
    isPPNonEligible=false;
    nonEligiblePP:any=[];
    isType3Removed=false;
    type3RemovedPP:any=[];
    cobuyeremail:string="";
    public nonToyotaProviderId: any = [];
    leaseMilageNew:number=0;
    leaseMilageUsed:number=0;
    checkMonthlyPayment:boolean = false;
    checkMonthlyPaymentFinalized:boolean = false;
  isIncentivesSelected: boolean=true;
  modifiedIncentiveIndex: number;
  initiateDealJacket: boolean=false;
  toastChatType: boolean=false;
    isCoBuyerEdited: boolean=false;
  initiatedWriteUpConvertionPaymentResponse: any;
  initiatedWriteUpConversion: boolean = false;
  rebateServiceDataForInitiatedWriteups: any;
  tradeWriteupResponseForCustomerUpdation: any;
  initiatedModalCounty: string ="";
  plateTransferUIStatus: any;
    showCreditModalFail: boolean;
  goodThroughError: boolean = false;
  quoteCalculatorTransactionId: string;
  deskingId: any; // used only in customerview page as of now
  deskingStatusMessage: any; // used only in customerview page as of now
  gridRowTabId: any; //used to get the row which is tabbed.
  tradeErrorSourceElement: any;
  selectedLenderforOnChangeRates: string;
    onChangeTermIndex: any =null;
    onChangeLender: any=[];
    onChangeTerm: any=[];
    oldTermArray: any[];
    dealDataPriceGridResponse: models.PricingDetails[];
    rollPaymentConditionBased: boolean = false;
    selectedPP: any;
    selectedPPforType3: any[];
    deleteNewTradeId: any=[];
    tradeProcessedTemplateModalClickedClose: boolean= false;
  InitiatedModaltradePaymentConversion: boolean;
  redirectToSummaryPage: boolean=false;
     public constructor(private store: Store<IAppCoreState>){
        let toDate = new Date();
        let fromDate = new Date();
        fromDate.setHours(0,0,0,0);
        toDate = new Date(toDate.setDate(toDate.getDate() + 1)); 
        fromDate = new Date(fromDate.setDate(fromDate.getDate() - 1));
        this.leadsFromDate = fromDate; this.writeupsFromDate = fromDate; this.byCustomerFromDate = fromDate;
        this.leadsToDate = toDate; this.writeupsToDate = toDate; this.byCustomerToDate = toDate;
    }

    tradeStatusSubject = new BehaviorSubject("");
    unselectRightPanelDealStatus = new BehaviorSubject("");
    dealTransactionId = new BehaviorSubject("");
    customerViewPageReloadSubject = new BehaviorSubject("");
    filteredWriteupsSubject = new BehaviorSubject([]);
    filteredLeadsSubject = new BehaviorSubject({});
    regionCode = new BehaviorSubject("");
    superMenuToggleSubject = new BehaviorSubject(false);
    profileTemplateToggleSubject = new BehaviorSubject(false);
    downloadToggleSubject = new BehaviorSubject(false);
    confirmTradeProcessTemplateSubject = new BehaviorSubject(false);
    removeTradeTemplateSubject = new BehaviorSubject(false);
    validationMessageTemplateSubject = new BehaviorSubject(false);
    offerValidationMessageTemplateSubject = new BehaviorSubject(false);
    goodThroughErrorTemplateSubject = new BehaviorSubject(false);
    tradeProcessedTemplateSubject = new BehaviorSubject(false);
    headerGoodThroughErrorTemplateSubject = new BehaviorSubject(false);
    calculateGoodThroughErrorTemplateSubject = new BehaviorSubject(false);
    calculateTradeEvaluationErrorTemplateSubject = new BehaviorSubject(false);
    contractStatusTemplateSubject = new BehaviorSubject(false);
    editDealTemplateSubject = new BehaviorSubject(false);
    emailClientTemplateSubject = new BehaviorSubject(false);
    digitalTransactionsTemplateSubject = new BehaviorSubject({});
    cardClickedSubject = new BehaviorSubject(false);
    isUserSalesConsultant: boolean = false;
    isUserAuthorized: boolean = false;
    paymentServiceSystemError: boolean = false;
    priceGridNAError: boolean = false;
    getVehicleAttributesMasterData = null;
    roleList: string;
    cw: number=0;
    dealerApproved: boolean =false;
    isGoClicked: boolean=false;
    count:number=0;
    dealApprovedMessageNotOpened: boolean=false;
    showLoader: boolean = false;
    serviceCallCount: number = 0;
    dealerCode: string;
    isPreferredViewDefault: boolean =  false;
    dealerName: string;
    isProtectionServiceFailed: boolean = false;
    dealerPersonnelName: string;
    dealerPersonnelFullName: string;
    seriesConfiguration=null;
    dealerPersonnelEmail: string;
    loggedInUserId: string;
    isOCASubmitted: boolean=true;
    isApplyForCreditWithoutConfirm: boolean = false;
    dealerAddress: string;
    new_pooled_dealers: any = [];
    used_pooled_dealers: any = [];
    smartPathDealer: boolean;
    isResidualOverrided: boolean= false;
    cashTransactionId: string;
    dealerEmail: string;
    dealerWebsite: string;
    dealerType: string;
    dealerPostalAddress: postalModels.PostalAddress;
    dealerZipCode: string;
    dealerPhoneNo: string;
    dealerPhoneNumberFromToken: any;
    relationshipTypeCode: string;
    divisionCodeValue: string;
    cloneResponse: any;
    disableConfirm: boolean;
    disableConfirmOnAstatus: boolean =false;
    loggedInUserName: string;
    isToggleEnabled: boolean;
    isActiveTab : string;
    cloneDealData: DealDetailView;
    savedDealId: string;
 
    public selectedDeal: models.DealRoute = {};
public initialLeaseType:any;
public isGridAgainClicked:boolean=false;
    public expiryDateSet: any;

    public customerObj: models.SalesAssociate = {};

    public kbbFlagValue: any;

    public politeLoading: boolean = false;

    public dealNotificationCount: number;

    public dealerConfig: boolean;

    public isDFIVisible: boolean;
    public isBusinessOCA: boolean;
    public isDealJacketVisible: boolean;
    public isDeskDealVisible: boolean;
    public isFIAdminUI: boolean;

    public protectionProduct: boolean;

    public resetTimer: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public stopTimer: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public disableTimer: boolean = false;
    public shortenUrlForPP: any;

    public openInitiatedWriteupFromDetailsAction: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public InitiatedWriteUpData: any;

    public showSubmitModal: boolean = false;
    public showCloneModal: boolean = false;
    public showPaymentSimulatorModal: boolean = false;
    public showDeskdealConfirmation: boolean = false;
    public showAdditionalBuyerInfo: boolean = false;
    public showCustomerInfoForInitited: boolean = false;
    public initiatedWriteupRowData: any;
    public openInitiateModal: boolean = false;
    public showAddressModal: boolean = false;
    public showChangeAddressModal: boolean = false;
    public selectedCellDataForInitiatedWriteUp: boolean = false;
    public showVSpecModal: boolean = false;
    public showShareConfigurationModal: boolean = false;
    public showSharePaymentEstimateModal: boolean = false;
    public showShareOCAModal: boolean =false;
    public showChangeVehicleModal: boolean = false;
    public showAdditionalBuyerModal: boolean = false;
    public editAdditionalBuyerModal: boolean = false;
    public removeAdditionalBuyerModal: boolean = false;
    public editCobuyer: boolean = false;
    public showCopyCoBuyerTradeModal: boolean = false;
    public selectCopyTradeCheckbox: boolean = false;
    public copyCobuyerTradeResponse:any;
    public cobuyerId: string = '';
    public customerId: string ='';
    public ChangeVehicleModal: boolean = false;
    public updateRebate: string[] = [];
    public duplicateupdateRebate: number[] = [];
    public showShareModalSuccess: boolean = false;
    public showShareModalFail: boolean = false;
    public coBuyerDetails: Object = {};
    public offerResponseFromInitiatedModal: Object = {};
    public showCoBuyerModal: boolean = false;

    public showChangeLogModal: boolean = false;

    public calculateClickedOnceAfterLoad: boolean =false;

    public tradeTabIndex: number;

    public loadProtectionProducts: boolean = false;

    private events = new BehaviorSubject<boolean>(false);

    private eventsPP = new BehaviorSubject<boolean>(false);

    private eventsPPTabChange = new BehaviorSubject<boolean>(false);

    private applyCashPP = new BehaviorSubject<boolean>(false);

    public isEditable: boolean;

    public setDealer: boolean;
    // public gstDealer: boolean;

    public gstDealer: boolean;

    public newTradeAdded: boolean = false;

    public vehicleOptionCode: Array<string>;
    public gridData: any;

    public cashDown: any;
    secondaryData: any;
    public isProtectionProductSelected: boolean = false;

    public isProtectionProductUpdate: boolean = false;
    public isOptionUpdate: boolean = false;
    public isEditPP: string;
    public isFromPayment: boolean = false;
    public isTradeProcessed: boolean = false;
    public salesPersonsData: any = null;
    public isNewTradeValid: boolean = true;
    public dropDownClicked:boolean=false;
    firstDueDate:string;
    public yearMakeModelVinMileageEdited: boolean = false;

    rollPayment:boolean = false;
    
    public isDesking: boolean;
    public showSendTransaction:boolean=true;
    public sendToTransactionsConfig: boolean;

    public firstDueSigning: boolean;

    public zeroDueSigning: boolean;
    
    public isUVIEndpoint: boolean = true;
    public isShareEnabled:boolean=false;
    public isOCAEnabled:boolean=false;
    public isShare2OnlineAccountEnabled:boolean=false;
    public isTcuvEnabled:boolean=true;
    public defaultSP:string=" ";
    public isAccessoriesModalOpened = false;
    public feaureDefaultValue: string = 'Finance';
    public rebateCapConfig:any;
    public tradeCapConfig:any;
    public cashdownCapConfig:any
    public salesTaxArrayFlag: boolean;

    public temp: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public grossProfitData: BehaviorSubject<any> = new BehaviorSubject(null);
    public grossProfitDataForSelectionCahnge: BehaviorSubject<any> = new BehaviorSubject(null);
    public dealData: BehaviorSubject<any> = new BehaviorSubject(null);

    public loadPEVersion: boolean;

    public applyCash: boolean = false;
    public resetProtectioProducts = false;
    public duplicateTermArray: any = [];
    public originalProtectioProducts:any;

    public originalDealProtectioProducts:any;

    public selectedMonthly:any;

    public specialRate:boolean;

    public previousMonthly:any;

    public estimatedPaymentGridData:models.EstimatedPayment[];
    
    public loaderFlag: boolean;

    public residualOverride: boolean;

    public isStandardLeaseFlag: boolean;

    public leaseVariant: boolean;

    public onePayLease: boolean;

    public leaseTypeChanged: boolean = false;

    public isMilesPerYearChanged: boolean;
    public defaultMiles:any;

    public dofu: string;
    
    public isCoBuyerEnable: boolean =false;
    public dofUpdated: boolean = false;

    public isGridSelectionChanged = false;
    public isGrossProfitEdited: boolean;

    public showLexusLoader: boolean = false;

    public selectedLeaseType: string = '';

    public setDataSubmitType: string;

    public sendEmailInSubmit: boolean = false;

    public showContractApproved: boolean = false;
    public aprMax:any;

    public isSpecialRateEnabled:boolean=false;
    get viewConstants() {
        return ViewConstants;
    }

    get screenMessages() {
        return ScreenMessages;
    }

    get screenLabels() {
        return ScreenLabels;
    }


    private totalValue: number = 0;
    private nameValuePair: any[] = [];
    private sourceKeys: string[] = [];

    public updateType: string;

    public dealDataResponse: models.DealDetails;

    IncrementServiceCallCount() {
        this.serviceCallCount++;
        this.SetShowLoader(true);
    }


    DecrementServiceCallCount() {
        this.serviceCallCount--;
        if (this.serviceCallCount === 0) {
            this.SetShowLoader(false);
        }
    }

    SetShowLoader(value: boolean) {
        setTimeout(() => {
            this.showLoader = value;
        }, 0);
    }


    getSelectedDeal() {
        return this.selectedDeal;
    }

    setSelectedDeal(selectedDeal: models.DealRoute) {
        this.selectedDeal = selectedDeal;
    }

    setExpiryDate(expiryDate: any) {
        this.expiryDateSet = expiryDate;
    }

    getExpiryDate() {
        return this.expiryDateSet;
    }

    setApplyCash(applyCash: boolean) {
        this.applyCash = applyCash;
        this.applyCashPP.next(applyCash);
    }

    public get showPopUpApplyCash(): Observable<boolean> {
        return this.applyCashPP.asObservable();
    }

    getApplyCash() {
        return this.applyCash;
    }

    setFirstDueDate(firstDueDate: any) {
        this.firstDueDate = firstDueDate;
    }

    getFirstDueDate() {
        return this.firstDueDate;
    }

    setDisable(isEditable: any) {
        this.isEditable = isEditable;
    }

    public getDisable() {
        return this.isEditable;
    }

    openPopUp(event) {
        this.events.next(event);
    }

    public get showPopUp(): Observable<boolean> {
        return this.events.asObservable();
    }
    
    openPopUpProtection(event) {
        this.eventsPP.next(event);
    }

    public get showPopUpProtection(): Observable<boolean> {
        return this.eventsPP.asObservable();
    }
    setPPTabChange(event) {
        this.eventsPPTabChange.next(event);
    }

    get pPTabChange(): Observable<boolean> {
        return this.eventsPPTabChange.asObservable();
    }

    // To do: #finish implementation
    handleError(error: any): Observable<any> {
        // input can be an error msg : string
        // or passed from http call
        return null;
    }

    public setRoles(roles: string): void {
        this.roleList = roles;
    }

    public getDealerNameFromToken(): string {
        return this.dealerName;
    }

    public getDealerPersonnelNameFromToken(): string {
        return this.dealerPersonnelName;
    }

    public setDealerPersonnelFullNameFromToken(given_name, family_name): void {
        this.dealerPersonnelFullName = given_name + ' ' + family_name;
    }

    public getDealerPersonnelFullNameFromToken(): string {
        return this.dealerPersonnelFullName;
    }

    public hasAccess(roleName: string): boolean {

        let arryRole: Array<string> = [];
        arryRole = roleName.split(ViewConstants.COMMA);
        let hasAccess: boolean = false;
        if (arryRole &&
            arryRole.filter(dt => this.roleList && this.roleList.indexOf(dt) > -1).length > 0) {
            hasAccess = true;
        }
        return hasAccess;
    }

    /**
     * Method to check the manager has access to DFI service
     */
    public hasDFIPresentationAccess() {
        let roleListArray = [];
        if (!isNil(this.roleList)) {
            roleListArray = this.roleList.split(this.viewConstants.COMMA);
            //return roleListArray.filter(dt => dt === 'DD_TFS_iRatebook').length === 1;
            // return (roleListArray.filter(dt => (dt.toLowerCase() === ViewConstants.DD_PPM_PRESENTATION.toLowerCase() || dt.toLowerCase() === ViewConstants.DD_TFS_FS_PRESENTATION.toLowerCase())).length >= 1 && this.isDFIVisible);
            let ppmPresentation = false, tfsPresentation = false;
            roleListArray.forEach(dt =>{
                if(dt.toLowerCase() === ViewConstants.DD_PPM_PRESENTATION.toLowerCase()){
                    ppmPresentation = true;
                }
                if(dt.toLowerCase() === ViewConstants.DD_TFS_FS_PRESENTATION.toLowerCase()){
                    tfsPresentation = true;
                }           
            })
            if (this.isDFIVisible) {
                if (tfsPresentation) {
                    if (ppmPresentation) {
                        return true;
                    } else {
                        return false;
                    }
                }
                if (ppmPresentation) {
                    return true;
                }
            } else {
                return false;
            }
        }
    }

    public hasSignalAccess() {
        return !isNil(this.roleList) && this.roleList.split(this.viewConstants.COMMA).includes(this.viewConstants.DD_SIGNAL);
    }

    public hasDeskingAccess() {
        return !isNil(this.roleList) && this.roleList.split(this.viewConstants.COMMA).includes('DD_Desking_Manager');
    }

    public hasDFIAdminAccess() {
        let roleListArray = [];
        let adminRole=false, iRateBook = false;
        if (!isNil(this.roleList)) {
            roleListArray = this.roleList.split(this.viewConstants.COMMA);
            // roleListArray = ['DD_DealerUser', 'DD_RTIExpressPurchaserole', 'DD_PAC_Management', 'DD_PPM_Presentation', 'DD_NewVehicleVMSExcludeCost', 'DD_UsedVehicleProcessing', 'DD_RTI_MST_CONSOLE', 'DD_Enrolled', 'DD_TFS_FS_Presentation', 'DD_PartsOrder', 'DD_NewVehicleVMSIncludeCost']
            // tslint:disable-next-line: max-line-length
            // return (roleListArray.filter(dt => (dt.toLowerCase() === ViewConstants.DD_FI_ADMINISTRATION.toLowerCase() || dt.toLowerCase() === ViewConstants.DD_TFS_IRATEBOOK.toLowerCase())).length >= 1); // As per MSTM-13723 now we're considering only DFI admin role
            // return (roleListArray.filter(dt => dt === 'DD_TFS_iRatebook').length === 1 && this.isDFIVisible);
            roleListArray.forEach(dt =>{
                if(dt.toLowerCase() === ViewConstants.DD_FI_ADMINISTRATION.toLowerCase()){
                    adminRole = true;
                }
                if(dt.toLowerCase() === ViewConstants.DD_TFS_IRATEBOOK.toLowerCase()){
                    iRateBook = true;
                }
            })            
            if (iRateBook) {
                if (adminRole) {
                    return true;
                }
                else {
                    return false;
                }
            }
            if (adminRole) {
                return true;
            }
        }
    }

    public hasPacManagementRole(): boolean {
        if (!isNil(this.roleList)) {
            const roleListArray = this.roleList.split(this.viewConstants.COMMA);
            return roleListArray.some(role => role.toLowerCase() === ViewConstants.DD_PAC_MANAGEMENT.toLowerCase());
        }
        return false;
    }

    constructVehicleInceptionMiles = (writupDetails): number => {
        if (writupDetails?.vehicle?.type.toLowerCase() !== ViewConstants.VEHICLE_TYPE_NEW) {
            return writupDetails?.priceGrid?.inceptionMiles?.toString() ?? 0;
        } else {
            return 0;
        }
    }

    public getPropertyValuesForMST(keyEndName: string, objectToIterate: any, getPropName?: any): any {
        this.totalValue = 0;
        this.nameValuePair = [];
        this.sourceKeys = [];
        this.calculateValuesForMST(keyEndName, objectToIterate, getPropName, null);
        return { totalValue: this.totalValue, nameValuePair: this.nameValuePair };
    }

    private calculateValuesForMST(keyEndName: string, objectToIterate: any, getPropName: any,
        keyToBeDisplayed: string) {
        let objectKeys = keysIn(objectToIterate);
        let loopKeys: string[] = objectKeys;
        if (!isNil(keyEndName) && keyEndName !== '') {
            loopKeys = objectKeys.filter(dt => dt.indexOf(keyEndName) !== -1 &&
                dt.indexOf(keyEndName) === (dt.length - keyEndName.length));
        }
        if (this.sourceKeys.length === 0) {
            this.sourceKeys = loopKeys;
        }
        loopKeys.forEach(key => {
            let propValue = objectToIterate[key];
            let propType = Object.prototype.toString.call(propValue) + '';
            let i = 0;
            if (propType.indexOf('Array') !== -1) {
                let tempArray: Array<any> = propValue;
                if (tempArray.length > 0) {
                    tempArray.forEach(arrayItem => {
                        i = i + (tempArray.length);
                        if (i <= tempArray.length) {
                            this.calculateValuesForMST(null, propValue, getPropName, key);
                        }
                    });
                }
            } else if (propType.indexOf('Object') !== -1) {
                if (key !== 'taxParameters') {
                    if (this.sourceKeys.indexOf(key) === -1)
                        this.calculateValuesForMST(null, propValue, getPropName, key);
                    else
                        this.calculateValuesForMST(null, propValue, getPropName, null);
                }
            } else if (!isNil(propValue) && !isNaN(propValue)) {
                this.totalValue = this.totalValue + parseFloat(propValue);
                if (!isNil(getPropName) &&
                    (Object.prototype.toString.call(getPropName) + '').indexOf('Function') !== -1) {
                    let tempKey = !isNil(keyToBeDisplayed) ? getPropName(keyToBeDisplayed) :
                        getPropName(key);
                    let nameValue: any = {};
                    let tempNameValuePair = this.nameValuePair.filter(nvp => nvp.name === tempKey);
                    if (this.removeTotalItems(tempKey)) // For Removing the Total details getting from response
                        if (!isNil(tempNameValuePair) && tempNameValuePair.length > 0) {
                            nameValue = tempNameValuePair[0];
                            if (isNil(nameValue.value)) {
                                nameValue.value = propValue;
                            }
                            else {
                                nameValue.value += parseFloat(propValue);
                                nameValue.value.toString();
                            }
                            //nameValue.value = propValue;
                        } else {
                            nameValue.name = tempKey;
                            if (isNil(nameValue.value)) {
                                nameValue.value = parseFloat(propValue);
                                nameValue.value.toString();
                            }
                            else {
                                nameValue.value += parseFloat(propValue);
                            }
                            //nameValue.value = propValue;
                            this.nameValuePair.push(nameValue);
                        }
                }
            }
        });
    }

    public removeTotalItems(key: string): boolean {
        const nonRemovableItems = [
            'totalCapitalizedFees',
            'totalCapitalizedTaxes',
            'totalNonCapitalizedFees',
            'totalNonCapitalizedTaxes',
            'totalFees',
            'totalTaxes'
        ];
        
        return !nonRemovableItems.includes(key);
    }    

    public setUserIdUserType(userId, userType, firstName, LastName) {
        this.customerObj.updatedByUserId = userId;
        this.customerObj.updatedByUserType = userType;
        this.customerObj.updatedBy = firstName + ' ' + LastName;
    }

    public getUserIdUserType() {
        return this.customerObj;
    }

    public getDSIFlag() {
        return this.isDFIVisible;
    }

    public setDealDataResponse(data: models.DealDetails) {
        this.dealDataResponse = data;
    } 

    public getDealDataResponse() {
        return this.dealDataResponse;
    }

    public setOriginalPriceGrid(data: models.DealDetails) {
        this.dealDataPriceGridResponse = data?.priceGrid?.details;
    } 

    public getOriginalPriceGrid() {
        return this.dealDataPriceGridResponse;
    }

    public setAndGetValues(key, isSetOperation, value): any {
        switch(key) {
            case 'vehicleOptionCode':
                if(isSetOperation) {
                    this.vehicleOptionCode = value;
                } else {
                    return this.vehicleOptionCode;
                }
                break;
            case 'dealDataResponse':
                if(isSetOperation) {
                    this.dealDataResponse = value;
                } else {
                    return this.dealDataResponse;
                }
                break;
            case 'updateType':
                if(isSetOperation) {
                    this.updateType = value;
                } else {
                    return this.updateType;
                }
                break;
            case 'salesTaxArrayFlag':
                if(isSetOperation) {
                    this.salesTaxArrayFlag = value;
                } else {
                    return this.salesTaxArrayFlag;
                }
                break;
            case 'dealerPersonnelEmail':
                if(isSetOperation) {
                    this.dealerPersonnelEmail = value;
                } else {
                    return this.dealerPersonnelEmail;
                }
                break;
            case 'dealerPhoneNumberFromToken':
                if(isSetOperation) {
                    this.dealerPhoneNumberFromToken = value;
                } else {
                    return this.dealerPhoneNumberFromToken;
                }
                break;
            case 'dealerPersonnelName':
                if(isSetOperation) {
                    this.dealerPersonnelName = value;
                } else {
                    return this.dealerPersonnelName;
                }
                break;
        }
    }

    setGridData(gridData:any, cashDown:any) {
        this.gridData = gridData;
        this.cashDown = cashDown
    }
    getGridData() {
        return this.gridData;
    }
    getCashDown(){
        return this.cashDown;
    }

    sortByIsFavorite(cardData: any[]) {
        let filterByIsFavorite: any = [];
        let filterByIsNotFavorite: any = [];

        if (cardData.length > 0) {
            filterByIsFavorite = cardData.filter((data: any) => data['isFavorite'] === true);
            this.sortByCreationDate(filterByIsFavorite);

            filterByIsNotFavorite = cardData.filter((data: any) => !data['isFavorite']);
            this.sortByCreationDate(filterByIsNotFavorite);
        }
        return [...filterByIsFavorite, ...filterByIsNotFavorite];
    }

    sortByCreationDate(cardData: []) {
        cardData.sort((a, b) => {
            return new Date(a['creationDateTime']).valueOf() - new Date(b['creationDateTime']).valueOf() || b['timeCreated'] - a['timeCreated'];
        })
    }

        // Conditions to verify the visibility of the Presentation Tab
   presentationTabVisibility() {
    if (this.isDFIVisible && this.protectionProduct) {
      return true;
    } else if (!this.isDFIVisible && this.protectionProduct) {
      return true;
    } else if (this.isDFIVisible && !this.protectionProduct) {
      return false;
    } else if (!this.isDFIVisible && !this.protectionProduct) {
      return false;
    }
  }

  insuranceTabVisibility(): boolean {
    return this.isDFIVisible && this.protectionProduct;
  }

    getOnlineStatus(deal): string {

        if (!isNil(deal) && !isNil(deal.onlineStatus)) {
            if (deal.origin || deal.salesPerson) {
                let origin = !isNil(deal.origin) ? deal.origin.toLocaleLowerCase() : "";
                let salesPerson = !isNil(deal.salesPerson) ? deal.salesPerson.toLocaleLowerCase() : "";
                if (origin === 'mstc' || origin === 'mst-c' || salesPerson === 'mstc' || salesPerson === 'mst-c') {
                    const statusMappings = {
                        'ready to share with dealer': 'Ready for Dealer',
                        'pending dealer review': 'Pending Review',
                        'ready for signature': 'Ready to Sign',
                        'ready for delivery': 'Ready to Deliver',
                        'cancelled': 'Cancelled',
                        'expired': 'Expired',
                        'contract approved': 'Contract Approved'
                    };

                    deal.onlineStatus = statusMappings[deal.onlineStatus.toLowerCase()] || deal.onlineStatus;
                } else {
                    let ds = deal.status ? deal.status.toLowerCase() : null;
                    if (ds == 'initiated' || ds == 'trade approved' || (deal.dealType && (deal.dealType.toUpperCase() == 'TRADEIN' || deal.dealType.toLowerCase() == 'trade') && ds == 'pending review')) {
                        deal.onlineStatus = 'Initiated'
                    } else if (ds == 'finalized' || ds == 'dealer approved' || ds == 'dfi submitted') {
                        deal.onlineStatus = 'Ready to Sign'
                    } else {
                        deal.onlineStatus = 'N/A';
                    }
                }
            } else {
                deal.onlineStatus = 'N/A';
            }
        } else {
            if (!isNil(deal))
                deal.onlineStatus = 'N/A';
            else {
                return 'N/A';
            }
        }
        return deal.onlineStatus;
    }

    setHideLoader(value: boolean) {
        this.loaderFlag = value;
    }

    getHideLoader() {
        return this.loaderFlag;
    }
    public stateDropdownOptions = [ 
        'STATE', 'ALABAMA', 'ALASKA', 'ARIZONA', 'ARKANSAS', 'CALIFORNIA', 'COLORADO', 'CONNECTICUT', 'DELAWARE', 'DISTRICT OF COLUMBIA',
        'FLORIDA', 'GEORGIA', 'HAWAII', 'IDAHO', 'ILLINOIS', 'INDIANA', 'IOWA', 'KANSAS', 'KENTUCKY', 'LOUISIANA',
        'MAINE', 'MARYLAND', 'MASSACHUSETTS', 'MICHIGAN', 'MINNESOTA', 'MISSISSIPPI', 'MISSOURI', 'MONTANA',
        'NEBRASKA', 'NEVADA', 'NEW HAMPSHIRE', 'NEW JERSEY', 'NEW MEXICO', 'NEW YORK', 'NORTH CAROLINA',
        'NORTH DAKOTA', 'OHIO', 'OKLAHOMA', 'OREGON', 'PENNSYLVANIA', 'RHODE ISLAND', 'SOUTH CAROLINA',
        'SOUTH DAKOTA', 'TENNESSEE', 'TEXAS', 'UTAH', 'VERMONT', 'VIRGINIA', 'WASHINGTON', 'WEST VIRGINIA',
        'WISCONSIN', 'WYOMING'
      ];
      public statesfullNameAbbreMap = {
        'AL': 'ALABAMA', 'AK': 'ALASKA', 'AZ': 'ARIZONA', 'AR': 'ARKANSAS', 'CA': 'CALIFORNIA',
        'CO': 'COLORADO', 'CT': 'CONNECTICUT', 'DE': 'DELAWARE', 'DC': 'DISTRICT OF COLUMBIA', 'FL': 'FLORIDA', 'GA': 'GEORGIA',
        'HI': 'HAWAII', 'ID': 'IDAHO', 'IL': 'ILLINOIS', 'IN': 'INDIANA', 'IA': 'IOWA',
        'KS': 'KANSAS', 'KY': 'KENTUCKY', 'LA': 'LOUISIANA', 'ME': 'MAINE', 'MD': 'MARYLAND',
        'MA': 'MASSACHUSETTS', 'MI': 'MICHIGAN', 'MN': 'MINNESOTA', 'MS': 'MISSISSIPPI',
        'MO': 'MISSOURI', 'MT': 'MONTANA', 'NE': 'NEBRASKA', 'NV': 'NEVADA', 'NH': 'NEW HAMPSHIRE',
        'NJ': 'NEW JERSEY', 'NM': 'NEW MEXICO', 'NY': 'NEW YORK', 'NC': 'NORTH CAROLINA',
        'ND': 'NORTH DAKOTA', 'OH': 'OHIO', 'OK': 'OKLAHOMA', 'OR': 'OREGON', 'PA': 'PENNSYLVANIA',
        'RI': 'RHODE ISLAND', 'SC': 'SOUTH CAROLINA', 'SD': 'SOUTH DAKOTA', 'TN': 'TENNESSEE',
        'TX': 'TEXAS', 'UT': 'UTAH', 'VT': 'VERMONT', 'VA': 'VIRGINIA', 'WA': 'WASHINGTON',
        'WV': 'WEST VIRGINIA', 'WI': 'WISCONSIN', 'WY': 'WYOMING'
      };

      getNonToyotaProductRequiredFields(productType:string, configData): any[]{
        let fieldIds;
        let fields;
        let provider;
        let providerOpions = [];
        let requiredFields = [];
        if(!isNil(configData)){
          for( const data in configData){
            if(!isNil(configData[data].dealerAddOnValidations) && Array.isArray(configData[data].dealerAddOnValidations)){
              let selectedProductType = configData[data].dealerAddOnValidations.find( v => v['optionsValue'].toLowerCase() == productType.toLowerCase());
              fieldIds = selectedProductType.requiredFields;
              break;
            }
          }
          for( const data in configData){
            if(!isNil(configData[data].fields) && Array.isArray(configData[data].fields)){
              fields = configData[data].fields
              break;
            }
          }
          for( const data in configData){
            if(!isNil(configData[data]) && Array.isArray(configData[data])){
              provider = configData[data].find(provider => provider.productCode.toLowerCase() == productType.toLowerCase());
              break;
            }
          }
        }
        if(!isNil(fieldIds) && !isNil(fields)){
          fieldIds.forEach(fieldId => {
            fields.forEach(field => {
              if(fieldId.toLowerCase() == field.fieldId.toLowerCase()){
                requiredFields.push(field);
              }
            });
          });
        }
        if(!isNil(provider) && !isNil(provider.providers) && Array.isArray(provider.providers)){
          provider.providers.forEach(provider => {
            for (const [key, value] of Object.entries(provider)) {
              providerOpions.push({'label': value, 'value':value})
            }
          });
        }
        if(!isNil(requiredFields)){
          requiredFields.forEach((field, index) => {
            if(field.fieldId.toLowerCase() == ViewConstants.PROVIDER.toLowerCase())
            requiredFields[index]['options'] = !isNil(providerOpions) ? providerOpions : [];
          })
        }
        return requiredFields;
      }
      getRequiredFieldsData(prodcutType, configData, formBuilder: UntypedFormBuilder){
        const requiredFields = this.getNonToyotaProductRequiredFields(prodcutType, configData);
        if(!isNil(requiredFields) && Array.isArray(requiredFields)){
            if(requiredFields.length > 0){
                const form = formBuilder.group({
                    productTitle: ['', Validators.required],
                    productTypes: [prodcutType, Validators.required],
                    dealerCost: ['', Validators.required],
                    retailMarkup: ['', Validators.required],
                    productDescription: ['', Validators.required]
                  });
                requiredFields.forEach(field => {
                  if(field.fieldId.toLowerCase() === ViewConstants.IS_CAPITALIZED.toLowerCase() || field.fieldId.toLowerCase() === ViewConstants.IS_TAXABLE.toLowerCase())
                  form.addControl(field.fieldId, formBuilder.control(false, Validators.required));
                  else form.addControl(field.fieldId, formBuilder.control('', Validators.required));
                });
            
                //putting the provider field at the beginning of required fields array.
                requiredFields.sort(field => field.fieldId.toLowerCase() === ViewConstants.PROVIDER.toLowerCase() ? -1 : 1);
            
                //to know if Capitalize checbox field is included in the required fields.
                const _isCapitalized = requiredFields.findIndex(field => field.fieldId.toLowerCase() === ViewConstants.IS_CAPITALIZED.toLowerCase());
                const isCapitalized = _isCapitalized != -1 ? true : false;
            
                //to know if Apply Tax checbox field is included in the required fields.
                const _isTaxable = requiredFields.findIndex(field => field.fieldId.toLowerCase() === ViewConstants.IS_TAXABLE.toLowerCase());
                const isTaxable = _isTaxable != -1 ? true : false;
            
                //excluding Capitalize and Apply Tax checbox fields from required fields array.
                const filteredRequiredFields = requiredFields.filter( field => field.fieldId.toLowerCase() !== ViewConstants.IS_TAXABLE.toLowerCase())
                .filter(field => field.fieldId.toLowerCase() !== ViewConstants.IS_CAPITALIZED.toLowerCase());
                const requiredFieldsNames = filteredRequiredFields.map(field => field.fieldName).join();
                return{form, isCapitalized, isTaxable, filteredRequiredFields, requiredFieldsNames}
            }
        }
        return null;
      }
    
    getRightPanelActiveCard() {
        return this.rightPanelProtectionProductActiveCard;
    }
    setRightPanelActiveCard(activeCard) {
        this.rightPanelProtectionProductActiveCard = activeCard;
    }
    setProtectionProductsOnLoad(ppData) {
        this.protectionProductsOnLoad = ppData;
    }
    getProtectionProductsOnLoad() {
        return this.protectionProductsOnLoad;
    }

    getDarkThemeValue(): boolean {
        let value: boolean;
        this.store.select(getMyTheme).subscribe((theme: boolean) => {
            value = theme;
        });
        return value;
    }

    closeModal = (): void => {
        const removeElements = (elements: HTMLCollectionOf<Element>): void => {
            while (elements.length > 0) {
                elements[0].remove();
            }
        };
        removeElements(document.getElementsByClassName("cdk-overlay-pane"));
        removeElements(document.getElementsByClassName('cdk-overlay-dark-backdrop'));
    }

    getCertificationType = (dealDetail): string => {
        const isCertified = dealDetail?.dealData?.vehicle?.type === ViewConstants.VEHICLE_TYPE_CERTIFIED;
        if (isCertified && dealDetail?.vehicleServiceResponse?.certificationType) {
            const certificationType = dealDetail.vehicleServiceResponse.certificationType.toLowerCase();
            return certificationType.includes(ViewConstants.GOLD.toLowerCase()) ? ViewConstants.GOLD_CERTIFIED : ViewConstants.SILVER_CERTIFIED;
        }
        return '';
    }
}